// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 642 ? "94a7ad86" : chunkId) + "." + {"548":"d0fa121d66943fcd","642":"4eb0ae22cd4167c1","779":"277ff32ba81dcc48"}[chunkId] + ".js";
};